export const votingContract = 'secret1md9vwn904hlxsy5v7d00muqrrevlds62amf2q7';
export const tokenContract = 'secret17w6pnfv0yn9k99dc8wttz5h0e0e6hz5pt8k2yu';
export const stakingContract = 'secret17hwxfnd5g6nx9q3qk3qppywxjpn65fvcaulp3r';
// export const tokenContract = 'secret1y5x6yrc4suagjvd3c6swjnv3r78rkrn2250l2e';
// export const stakingContract = 'secret1ajjtydcgzjf8wg9m0y454dq72nk9lajrhkuj85';
